import CreateFetch from '@/common/utils/createFetch';
import AcronisHttpAdapter from '@/common/utils/acronisHttpAdapter';
import BASE_CONFIG from '@/common/appConfig';
import type { AxiosInstance } from 'axios';
import { store } from '@/common/root';
import type { useAuthStore } from '@/common/store/pinia/auth';
import type useAppModeStore from '@/common/store/pinia/appMode';
import { buildAcronisWebsocketSettings } from './buildAcronisWebsocketSettings';

const api: AcronisHttpAdapter | CreateFetch = BASE_CONFIG.isFederated ? new AcronisHttpAdapter() : new CreateFetch();

export const initApi = ({
  httpAdapterFromProvider,
  authStore,
  appModeStore
}: { httpAdapterFromProvider?: AxiosInstance, authStore: ReturnType<typeof useAuthStore>, appModeStore?: ReturnType<typeof useAppModeStore> }) => {
  if (appModeStore && httpAdapterFromProvider && api instanceof AcronisHttpAdapter) {
    api.setInstance(httpAdapterFromProvider);
    const settings = buildAcronisWebsocketSettings(api);
    appModeStore.setSettings(settings);
  }

  api.setAdapter({
    unauthorize: () => authStore.signOut(),
    checkReconfiguration: () => store.dispatch('reconfiguration/CHECK_RECONFIGURATION'),
    checkAccessDisabled: async () => {
      await authStore.checkAccessDisabled();
    },
    getScopedToken: () => authStore.getScopedToken || '',
  });

  return api;
};

export default api;
